import { PT, uid, borderInset } from "@/lib/layout";

const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
const q = (v) => Math.round(v * 2) / 2;

export function applyTemplate(product, tpl, prev) {
  const cfg = product.config;
  const W = product.width_mm, H = product.height_mm;
  const round = product.shape === "round" || product.shape === "oval";
  const allowed = cfg.allowed_fonts?.length ? cfg.allowed_fonts : null;
  const font = tpl.font && (!allowed || allowed.includes(tpl.font)) ? tpl.font : cfg.default_font || "arimo";
  const max = cfg.customer_can_add_lines ? cfg.max_lines : Math.max(1, cfg.default_lines?.length || 1);
  const texts = tpl.lines.slice(0, Math.max(1, max));
  const n = texts.length;
  const border = prev?.border || { style: "none", width_pt: 1 };
  const m = (cfg.margin_mm ?? 1) + borderInset(border);
  const availH = round ? Math.min(W, H) * 0.5 : H - 2 * m;
  const body = clamp(q((availH / Math.max(n + 0.4, 1) / 1.15 / PT) * 0.95), cfg.min_font_pt, cfg.max_font_pt);
  const mk = (text, i, extra = {}) => ({
    id: uid(), text, font, size_pt: i === 0 ? clamp(q(body * 1.3), cfg.min_font_pt, cfg.max_font_pt) : body, bold: i === 0 && font === "arimo",
    italic: false, underline: false, align: "center", curve: null, offset_x: 0, offset_y: 0, letter_spacing_mm: 0, pristine: true, ...extra,
  });
  let lines;
  if (round && cfg.allow_curved_text && n >= 3) {
    const arc = clamp(q(Math.min(W, H) / 4.5), cfg.min_font_pt, cfg.max_font_pt);
    const up = (t) => (tpl.font ? t : t.toUpperCase());
    lines = [mk(up(texts[0]), 0, { curve: "top", size_pt: arc, bold: true }),
      ...texts.slice(1, -1).slice(0, Math.max(1, max - 2)).map((t, k) => mk(t, k + 1, { size_pt: clamp(q(arc * 0.75), cfg.min_font_pt, cfg.max_font_pt) })),
      mk(up(texts[n - 1]), 1, { curve: "bottom", size_pt: clamp(q(arc * 0.9), cfg.min_font_pt, cfg.max_font_pt) })];
  } else lines = texts.map((t, i) => mk(t, i));
  const kept = (prev?.graphics || []).filter((g) => g.type !== "clipart");
  const graphics = [...kept];
  if (tpl.icon && cfg.allow_clipart && cfg.max_graphics > graphics.length && !round && W >= 40 && !kept.some((g) => g.x + g.w / 2 < W / 2)) {
    const h = Math.round((H - 2 * m) * 0.6 * 10) / 10;
    graphics.push({ id: uid(), type: "clipart", name: tpl.icon, ratio: 1, x: Math.round((m + 0.5) * 10) / 10, y: Math.round(((H - h) / 2) * 10) / 10, w: h, h });
  }
  return { lines, graphics, border, line_spacing: 1.15, autofit: true, block_x: 0, block_y: 0 };
}

export const tplSlug = (name) => name.toLowerCase().normalize("NFD").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
